module.exports = __webpack_public_path__ + "assets/img/DS-room3 (10).149b0660.jpg";